/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputUavWaypoint } from './OutputUavWaypoint';
import {
    OutputUavWaypointFromJSON,
    OutputUavWaypointFromJSONTyped,
    OutputUavWaypointToJSON,
} from './OutputUavWaypoint';

/**
 * 
 * @export
 * @interface OutputUavMissionTrackRevision
 */
export interface OutputUavMissionTrackRevision {
    /**
     * Approximate — збереженої версії немає (заявка старша за журнал версій), віддано поточний
     * маршрут заявки: він міг змінитись після вильоту.
     * @type {boolean}
     * @memberof OutputUavMissionTrackRevision
     */
    approximate?: boolean;
    /**
     * CreatedAt — коли версія з'явилась (RFC3339); порожньо для Approximate.
     * @type {string}
     * @memberof OutputUavMissionTrackRevision
     */
    createdAt?: string;
    /**
     * 
     * @type {Array<OutputUavWaypoint>}
     * @memberof OutputUavMissionTrackRevision
     */
    flightPath?: Array<OutputUavWaypoint>;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionTrackRevision
     */
    loiterHeadingDeg?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionTrackRevision
     */
    loiterLat?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionTrackRevision
     */
    loiterLng?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionTrackRevision
     */
    loiterRadiusM?: number;
}

/**
 * Check if a given object implements the OutputUavMissionTrackRevision interface.
 */
export function instanceOfOutputUavMissionTrackRevision(value: object): boolean {
    return true;
}

export function OutputUavMissionTrackRevisionFromJSON(json: any): OutputUavMissionTrackRevision {
    return OutputUavMissionTrackRevisionFromJSONTyped(json, false);
}

export function OutputUavMissionTrackRevisionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUavMissionTrackRevision {
    if (json == null) {
        return json;
    }
    return {
        
        'approximate': json['approximate'] == null ? undefined : json['approximate'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'flightPath': json['flightPath'] == null ? undefined : ((json['flightPath'] as Array<any>).map(OutputUavWaypointFromJSON)),
        'loiterHeadingDeg': json['loiterHeadingDeg'] == null ? undefined : json['loiterHeadingDeg'],
        'loiterLat': json['loiterLat'] == null ? undefined : json['loiterLat'],
        'loiterLng': json['loiterLng'] == null ? undefined : json['loiterLng'],
        'loiterRadiusM': json['loiterRadiusM'] == null ? undefined : json['loiterRadiusM'],
    };
}

export function OutputUavMissionTrackRevisionToJSON(value?: OutputUavMissionTrackRevision | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'approximate': value['approximate'],
        'createdAt': value['createdAt'],
        'flightPath': value['flightPath'] == null ? undefined : ((value['flightPath'] as Array<any>).map(OutputUavWaypointToJSON)),
        'loiterHeadingDeg': value['loiterHeadingDeg'],
        'loiterLat': value['loiterLat'],
        'loiterLng': value['loiterLng'],
        'loiterRadiusM': value['loiterRadiusM'],
    };
}

